import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-accent md:text-s flex w-full items-center gap-2 py-2 pr-4 pl-3 text-xs leading-(--leading-xs) font-light md:gap-6 md:p-5 md:leading-(--leading-s) lg:py-3',
    image: 'size-[44px] max-w-[44px] flex-1 lg:size-[84px] lg:max-w-[84px]',
    link: 'link mt-0.5 flex items-center font-semibold md:mt-1.5',
    arrow: 'mt-0.75 ml-2.25'
  },
  variants: {
    rounded: {
      true: {
        base: 'rounded-[100px] bg-linear-98 from-[#F6FDFF] to-[#EEF3FF] px-5 py-3 md:pr-8'
      }
    }
  }
});
